export enum StorageItemKeyEnum {
  activeProcessesIds = 'activeProcessesIds',
  onBehalfOfUser = 'onBehalfOfUser',
  otpRequestTimer = 'otpRequestTimer',
  brandingData = 'brandingData',
  fileOnline = 'fileOnline',
  FileOpened = 'fileOpened',
  Token = 'token',
  AppUser = 'appUser',
}
